import script from "./ParticleCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticleCanvas.vue?vue&type=script&setup=true&lang=js"

import "./ParticleCanvas.vue?vue&type=style&index=0&id=c9deee28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9deee28"]])

export default __exports__